import CloudinaryImage from '@/components/CloudinaryImage'

const HERO_IMG_PATH = 'global/arcade/'
const HERO_IMG_ID = 'quickStatsLogo'

export const Header = () => (
  <header className="flex items-center justify-center w-full">
    <div className="relative w-full h-3">
      <CloudinaryImage
        path={HERO_IMG_PATH}
        imageId={HERO_IMG_ID}
        layout="fill"
        objectFit="contain"
        alt="Arcade"
      />
    </div>
  </header>
)
